import { css } from "@emotion/react";
import React, { PropsWithChildren } from "react";
import T from "../components/text/Text";
import Icon from "../components/Icon";
import Intersperse from "../components/Intersperse";
import Spacer from "./Spacer";

type EmptyViewProps = PropsWithChildren<{
  message?: string;
  grow?: boolean;
  style?: "normal" | "discreet";
}>;

export default function EmptyView(props: EmptyViewProps) {
  const { message, grow, style = "normal" } = props;

  const containerCss = css({
    flexGrow: grow ? 1 : 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  });

  return (
    <div css={containerCss}>
      <Intersperse Component={Spacer}>
        {style === "normal" ? (
          <Icon name="help" size={60} opacity={0.2} />
        ) : null}
        <T style={style === "normal" ? "body" : "minor"} align="center">
          {message}
        </T>
        {props.children ? <div>{props.children}</div> : null}
      </Intersperse>
    </div>
  );
}
